<template>
  <div>
    <v-col cols="12">
      <v-row>
        <v-col cols="2">
          <v-menu
            ref="report_month"
            v-model="report_month"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            persistent
            offset-y
            min-width="290px"
            style="z-index: 3"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="report_month_data"
                label="Select Month"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="report_month_data"
              type="month"
              scrollable
              v-if="report_month"
            ></v-date-picker>
            <!-- <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker> -->
          </v-menu>
        </v-col>
        <v-col cols="6">
          <v-btn color="success" style="float: left" @click="loadData"
            >LOAD DATA</v-btn
          ></v-col
        >
        <v-col cols="4">
          <v-select
            :items="listPosition"
            v-model="positionSelected"
            outlined
            dense
            small-chips
            multiple
            label="Filter By Position"
            @change="filterData"
          ></v-select>
        </v-col>
      </v-row>

      <v-col v-if="informText != ''">
        <v-alert type="error">{{ informText }}</v-alert>
      </v-col>

      <v-data-table
        :headers="headers"
        :items="listBonus"
        class="elevation-1"
        :loading="loading"
        :search="search"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search user"
              single-line
              hide-details
              class="shrink mx-4"
              title="Tìm kiếm"
            ></v-text-field>
            <v-divider class="mx-4" inset vertical></v-divider>
            <template>
              <b
                >Total Gross Bonus:
                <span style="color: green">
                  ${{ parseFloat(total_gross_bonus).toFixed(2) }}
                </span>
                - Total Net Bonus:
                <span style="color: green"
                  >${{ parseFloat(total_net_bonus).toFixed(2) }}</span
                ></b
              >
            </template>
          </v-toolbar>
        </template>

        <template v-slot:item.name="{ item }">
          {{ item.name }}
        </template>
        <template v-slot:item.total_invalid_checkins="{ item }">
          {{ item.total_invalid_checkins }}
        </template>
        <template v-slot:item.personal_checkin_donate="{ item }">
          {{ parseFloat(item.personal_checkin_donate * 100).toFixed(2) }}%
        </template>
        <template v-slot:item.team_checkin_donate="{ item }">
          {{ parseFloat(item.team_checkin_donate * 100).toFixed(2) }}%
        </template>
        <template v-slot:item.checkin_donate="{ item }">
          {{ parseFloat(item.checkin_donate * 100).toFixed(2) }}%
        </template>
        <template v-slot:item.gross_bonus="{ item }">
          {{ parseFloat(item.gross_bonus).toFixed(2) }}
        </template>
        <template v-slot:item.net_bonus="{ item }">
          <template v-if="item.net_bonus != 'NaN'">
            ${{ parseFloat(item.net_bonus).toFixed(2) }}
          </template>
          <template v-else>NaN</template>
        </template>
        <template v-slot:item.positions="{ item }">
          <td>
            <v-menu
              :close-on-content-click="false"
              :nudge-width="200"
              offset-x
              persistent
            >
              <template v-slot:activator="{ on, attrs }">
                <a v-bind="attrs" v-on="on">
                  {{ item.positions.length }} position(s)
                </a>
              </template>
              <v-card
                class="mx-auto positions-scroll"
                max-width="344"
                outlined
                style="font-size: 14px"
              >
                <template v-for="(i, index) in item.positions">
                  <v-list-item
                    three-line
                    v-if="i.selected"
                    :key="index"
                    class="border"
                  >
                    <v-list-item-content style="text-align: left">
                      <div v-for="(value, text, jindex) in i" :key="jindex">
                        <template v-if="text != 'selected'">
                          <b>{{ text }}</b
                          >:
                          <template v-if="typeof value == 'string'">{{
                            value
                          }}</template>
                          <template v-else>{{
                            parseFloat(value).toFixed(2)
                          }}</template>
                        </template>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-card>
            </v-menu>
          </td>
        </template>
      </v-data-table>
    </v-col>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment-timezone";
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "BonusList",

  data: () => ({
    roles: [],
    listBonus: [],
    loading: false,
    report_month: "",
    report_month_data: "",
    search: "",
    total_net_bonus: 0,
    total_gross_bonus: 0,
    listPosition: [],
    positionSelected: [],
    informText: "",
    headers: [
      {
        text: "User",
        align: "start",
        value: "name",
      },
      { text: "Positions", value: "positions" },
      { text: "Total Invalid Check Ins", value: "total_invalid_checkins" },
      { text: "Personal Checkin Donate", value: "personal_checkin_donate" },
      { text: "Team Checkin Donate", value: "team_checkin_donate" },
      { text: "Total Checkin Donate", value: "checkin_donate" },
      { text: "Gross Bonus", value: "gross_bonus" },
      { text: "Net Bonus", value: "net_bonus" },
    ],
  }),

  methods: {
    async loadData() {
      this.informText = "";
      this.loading = true;
      this.total_net_bonus = 0;
      this.total_gross_bonus = 0;
      this.listBonus = [];
      this.listBonusTemp = [];
      this.listPosition = [];
      this.positionSelected = [];
      var currentSession = await this.$root.$refs.App.currentSession(
        "bonus-loadData"
      );
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "bonus", {
            headers: { Authorization: currentSession.accessToken },
            params: { report_month: this.report_month_data },
          })
          .then((response) => {
            console.log("bonus Response: ", response);
            if (response.data.data.length >= 0) {
              if (response.data.data != "") {
                this.listBonus = response.data.data;
              }
              this.listBonusTemp = JSON.parse(JSON.stringify(this.listBonus));
              var temp = new Set();
              for (const i of this.listBonus) {
                for (const j of i.positions) {
                  temp.add(j.position_name);
                  j["selected"] = true;
                }
                this.total_gross_bonus += i.gross_bonus;
                this.total_net_bonus += i.net_bonus;
              }
              for (const t of this.listBonusTemp) {
                for (const x of t.positions) {
                  x["selected"] = false;
                }
              }
              this.listPosition = Array.from(temp);

              this.listPosition.sort();
              console.log(this.listPosition);
            } else {
              this.informText = response.data.error_message;
            }
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log(
          "currentSession bonus-loadData-undefined: ",
          currentSession
        );
      }
      this.loading = false;
    },

    filterData() {
      this.listBonus = JSON.parse(JSON.stringify(this.listBonusTemp));
      //console.log(this.listBonus);
      this.total_gross_bonus = 0;
      this.total_net_bonus = 0;
      if (this.positionSelected.length > 0) {
        for (const i of this.positionSelected) {
          for (const j of this.listBonus) {
            for (const k of j.positions) {
              if (k.position_name == i) {
                k["selected"] = true;
              }
            }
          }
        }

        for (const l of this.listBonus) {
          l.gross_bonus = 0;
          l.net_bonus = "NaN";
          var count = 0;
          for (const m of l.positions) {
            if (m.selected == true) {
              l.gross_bonus += m.bonus;
              count += 1;
            }
          }

          if (count > 0) {
            l["choose"] = true;
          } else {
            l["choose"] = false;
          }

          this.total_gross_bonus += l.gross_bonus;
        }

        for (const k in this.listBonus) {
          if (!this.listBonus[k].choose) {
            delete this.listBonus[k];
          }
        }
      } else {
        for (const t of this.listBonus) {
          for (const x of t.positions) {
            x["selected"] = true;
          }
          this.total_gross_bonus += t.gross_bonus;
          this.total_net_bonus += t.net_bonus;
        }
      }
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("bonus");
    if (this.roles.list_bonuses) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    var date = new Date();
    this.report_month_data = moment(date).format("YYYY-MM");

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      await this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style lang="scss" scoped>
.positions-scroll {
  height: 40vh;
  overflow: auto;
}
</style>